'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from '../styles/Promo.module.css';
import gradientStyles from '../styles/GradientOverlay.module.css';
import Image from 'next/image';
const Promo = () => {
  const promoRef = useRef(null);
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    // Use a slight delay to ensure DOM is fully hydrated
    const animationDelay = setTimeout(() => {
      const promo = promoRef.current;
      if (!promo) return;
      
      // Parallax effect for the background
      gsap.to(`.${styles.promoBg}`, {
        scrollTrigger: {
          trigger: promo,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        },
        y: '25%',
        ease: 'none'
      });
      
      // Text animation
      gsap.from(`.${styles.promoHeader} h1, .${styles.promoHeader} h2`, {
        scrollTrigger: {
          trigger: promo,
          start: 'top 80%',
          end: 'center center',
          scrub: true
        },
        y: 50,
        opacity: 0,
        stagger: 0.3,
        ease: 'power3.out'
      });
    }, 100); // Small delay to ensure everything is rendered
    
    return () => clearTimeout(animationDelay);
  }, []);
  
  return (
    <section className={styles.promo} id="cases" ref={promoRef}>
      <div className={styles.promoBg}>
        <Image 
          src="https://imagedelivery.net/LOBxX7gyPpyC22XVZKaoOw/e2fb6056-f28c-4de9-21a0-4bb2f8b69100/public" 
          alt="Background gradient" 
          className={gradientStyles.gradientImage}
          width={1920}
          height={1080}
          priority
        />
      </div>
      <div className={styles.promoHeader}>
        <h1>GAM</h1>
        <h2>Token</h2>
        <h2>Presale</h2>
        
      </div>
    </section>
  );
};

export default Promo; 